import { createGuid, getMeta, getDynData } from "../../scripts/general_functions";
import { getImageByContentId } from "../../scripts/images";
//import { checkNested, getConfig, createGuid, getMeta, getDynData, testDynData, getDynDataOne } from "./general_functions";
import language from "../../scripts/translation";

export const getProjects = (load = 3, from = 0, callback) => {
    const data = { 
        "categoryId": 'e91af1d7-519b-475e-a338-fbd00746f954', 
        "subscriptionId": client.clientId 
    };

    fetch(window.apiUrl + '/api/PublicContentApi/getbycategoryidasstring', { 
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    }).then(results => results.json()).then(data => {
        callback(data);
    });
}
export const projectsFront = (maxItems = 3, moduleTitle) => {

    getProjects(100, 0, (data) => {
        let projects = [];
        let projectCount = 0;

        if (data.length > 0) {
            data.forEach(project => {
                let meta = getMeta(project);
                let details = getDynData(meta);
                let projectGuid = createGuid();

                if (projectCount < maxItems && project.title) {
                    let image = ``;
                    let hasImage = false;
                    let cloudinaryUrl = "";

                    if (meta.imageContentId) {
                        hasImage = true;
                        image = `<div class="project__image_container"><img src='' id='project__${projectGuid}' class="project__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}"></div>`;
                        getImageByContentId(meta.imageContentId, (img) => {
                            if ($(document).width() < 768) {
                                //Mobile view
                                cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_345,h_195,c_fill/" + img.url;
                            }
                            else {
                                //Desktop view
                                if (maxItems == 1) {
                                    cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_180,h_180,c_fill/" + img.url;
                                }
                                else {
                                    cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_360,h_200,c_fill/" + img.url;
                                }
                            }
                            $(`#project__${projectGuid}`).attr("src", cloudinaryUrl);
                        });
                    }

                    let link = `/artikkel/${project.nameInUrl}`;
                    let linktext = "Les mer her";
                    let dynLink = getDynData(meta, "dddc6cac-9579-4d59-9f52-c3a85ca05473").res;

                    if (dynLink) {
                        link = dynLink; //`<span class="project__link">Gå til siden</span>`;
                        linktext = language("project_GOTOPAGE");
                    }

                    projectCount++;
                    projects.push(`
                        <a class="project__item" href="${link}">
                            ${image}
                            <div class="project__content">
                                <span class="material-icons-outlined menu-icon"></span><span class="project__title">${project.title}</span>
                                <!--p class="project__text">${project.intro}</p-->
                            </div>
                        </a>
                    `);
                }
            });
        }




        if (projects.length < 1) {
            $("#projects>div").html("");
        }
        else {
            $("#projects").html(projects.join(""));
            if(projects.length < data.length) {
                // $("#projects").append(`<div class="justify-content-center-"><a class="simple-button-plugin" href="/nav/prosjekter" target="_blank">${language("NEWS_SEEALL")}</a></p>`);
            }
        }
    })


    return `
        <section  id="module__projects" class="p-md-0 justify-content-md-center">
            <div class="container p-0">
                <div class="row">
                    <div class="col"><h2 class="project__module__title">${moduleTitle != undefined ? moduleTitle : ``}</h2></div>
                </div>
                <div class="project" id="projects">
                </div>
                <div class="row">
                    <div class="col text-center">
                        <div class="project__more__container">
                            <a class="simple-button-plugin" href="/nav/prosjekter" target="_blank">${language("PROJECTS_SEEALL") != "PROJECTS_SEEALL" ? language("PROJECTS_SEEALL") : `Se flere prosjekter `} <span class="material-icons-outlined news__more__icon">&#xE5C8;</span></a>
                        </div>
                    </div>
                </div>

            </div>
        </section>`;
}
